import { render, staticRenderFns } from "./CardsSwiper.vue?vue&type=template&id=43dbcf7e&scoped=true&"
import script from "./CardsSwiper.vue?vue&type=script&lang=js&"
export * from "./CardsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CardsSwiper.vue?vue&type=style&index=0&id=43dbcf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbcf7e",
  null
  
)

export default component.exports